<script>
import SideMenuItem from '../side-menu-item';
import Config       from '../../../../libs/config';

export default {
  name  : 'side-menu-item-help',
  mixins: [SideMenuItem],
  data  : function() {
    return {
      label    : 'ヘルプ',
      link     : Config.SERVICE_LINK.ATCOSME.HELP.SP.URL,
      analytics: this.$parent.analytics,
    };
  },
};
</script>
